import { handleResult, postForm, postQuery } from '../http';
import confirmDialog from './confirm-dialog';

// Activate / deactivate for the list pages. Rows hold their own `active` flag
// (and optionally `status`, the job status column) and ask with:
//   $dispatch('status-request', { id, name, row: $data })
// By default it POSTs `{field}=<id>` form-encoded to {url}/activate or
// {url}/deactivate. `paths` renames those actions and `query: true` sends the
// id in the query string instead, which is what the user, recruiter and job
// endpoints expect.
//
// Job/Edit renders some modal partials twice, so only the first dialog for a
// given endpoint answers.
const registered = new Set();

export default ({ url, field, noun, paths = { activate: 'activate', deactivate: 'deactivate' }, query = false }) => ({
  ...confirmDialog(),

  duplicate: false,

  init() {
    const key = `${url}|${paths.activate}|${field}`;
    this.duplicate = registered.has(key);
    registered.add(key);
  },

  ask({ id, name, row }) {
    if (this.duplicate) {
      return;
    }

    const activate = !row.active;

    this.show({
      title: `${activate ? 'Activate' : 'Deactivate'} this ${noun}?`,
      name,
      message: `will be marked as ${activate ? 'active' : 'inactive'}.`,
      confirmLabel: activate ? 'Activate' : 'Deactivate',
      tone: activate ? 'primary' : 'danger',
      action: async () => {
        const send = query ? postQuery : postForm;
        const response = await send(`${url}/${activate ? paths.activate : paths.deactivate}`, { [field]: id });

        handleResult(response, (data) => {
          row.active = activate;

          if (row.status !== undefined) {
            row.status = data.jobStatus || '';
          }
        });
      },
    });
  },
});
